import { render, staticRenderFns } from "./InsureCompany.vue?vue&type=template&id=83a369ba&scoped=true&"
import script from "./InsureCompany.vue?vue&type=script&lang=js&"
export * from "./InsureCompany.vue?vue&type=script&lang=js&"
import style0 from "./InsureCompany.vue?vue&type=style&index=0&id=83a369ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a369ba",
  null
  
)

component.options.__file = "InsureCompany.vue"
export default component.exports